import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchIndustries,deleteIndustry,fetchAllIndustriesList } from '../services/userIndustry';
import { toast } from 'react-toastify';

export const useFetchIndustryTable = (industriesType, filteredData) => {
    return useQuery({
        queryKey: ['Industry', { industriesType, filteredData }], // Unique query key
        queryFn: fetchIndustries, // Pass a function reference
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};

export const useFetchIndustries = () => {
    return useQuery({
        queryFn: fetchIndustries, // Pass a function reference
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};
export const useFetchAllIndustriesList = () => {
    return useQuery({
        queryKey: ['industries'],
        queryFn: fetchAllIndustriesList, // Pass a function reference
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
}
// Hook to delete an organization
export const useDeleteIndustry = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteIndustry,
        onSuccess: (response) => {
            if (response.status === 200 || response.status === 201) {
                toast.success(response?.data?.message || 'Industry deleted successfully.');
                queryClient.invalidateQueries(['Industry']); // Refetch organizations on successful deletion
            }
        },
        onError: (error) => {
            toast.error('Error deleting Industry.');
            console.error('Error deleting Industry:', error);
        },
    });
};
